import { controllerFactory } from "@utils/createController";

export default class extends controllerFactory<HTMLFormElement>()({
  targets: {
    checkbox: HTMLDivElement,
    form: HTMLFormElement,
  },
  values: {
    forRelation: String,
  },
}) {
  change(): void {
    const values: string[] = [];
    this.formTarget.querySelectorAll("input:checked").forEach((checkbox) => {
      values.push(checkbox.value.split("-")[0]);
    });

    if (values.length > 0) {
      this.checkLinkables(`linkability/${values.join("/")}`);
    } else {
      this.resetForm();
      this.checkLinkables();
    }
  }

  checkLinkables(url?: string): void {
    const labelId = this.formTarget
      .getAttribute("action")!
      .split("/")
      .pop()
      ?.split("-")[0];

    if (url == undefined) {
      if (this.forRelationValue == "parent_label_ids") {
        url = "availableParents";
      } else {
        url = "availableChildren";
      }
    }

    fetch(`/labels/${labelId}/${url}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        return response.json();
      })
      .then((data) => {
        this.resetForm();
        data.forEach((relativeId) => {
          const checkbox = this.formTarget.querySelector(
            `input[id^='id-${relativeId}']`,
          ) as HTMLInputElement;
          if (!checkbox?.checked) {
            this.disableCheckbox(checkbox as HTMLInputElement);
          }
        });
      })
      .catch((error) => console.error("Error:", error));
  }

  connect(): void {
    this.checkLinkables();
  }

  disableCheckbox(checkbox: HTMLInputElement): void {
    checkbox?.setAttribute("disabled", "true");
    const container = checkbox?.closest(
      "[data-ariadne-ui-list-target=searchString]",
    );
    container?.classList.add("opacity-50");
  }

  enableCheckbox(checkbox: HTMLInputElement): void {
    checkbox?.removeAttribute("disabled");
    const container = checkbox?.closest(
      "[data-ariadne-ui-list-target=searchString]",
    );
    container?.classList.remove("opacity-50");
  }

  resetForm(): void {
    this.formTarget.querySelectorAll("input").forEach((checkbox) => {
      this.enableCheckbox(checkbox as HTMLInputElement);
    });
  }
}
